import { render } from "./ActasJrvStreamlined.vue?vue&type=template&id=53867ac4&scoped=true"
import script from "./ActasJrvStreamlined.vue?vue&type=script&lang=ts"
export * from "./ActasJrvStreamlined.vue?vue&type=script&lang=ts"

import "./ActasJrvStreamlined.vue?vue&type=style&index=0&id=53867ac4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53867ac4"

export default script